<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
img{
  display: inline-block!important;
}
#app {
  overflow-x: hidden;
  width: 100%;
}

.title-right-box {
  font-size: 14px;
  color: #666!important;

  i {
    margin-right: 5px!important;
  }
  .icon-home{
    cursor: pointer!important;
  }
}

.el-pagination {
  margin-top: 15px;

}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #D30A1D !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue